import { Column, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterRbacRoleEntity } from './m-sfp-smart-filter-rbac-role.entity';

@Entity('m_sfp_smart_filter_module', {}, { label: 'Smart Filter Module' })
export class MSfpSmartFilterModuleEntity extends BaseEntity {
	@Column('varchar', { name: 'key', length: 255 })
	public key!: string;

	@Column('varchar', { name: 'label', length: 64 })
	public label!: string;

	@OneToMany(
		() => MSfpSmartFilterRbacRoleEntity,
		(mSfpSmartFilterRbacRole) =>
			mSfpSmartFilterRbacRole.fkMSfpSmartFilterModule,
		{},
	)
	public mSfpSmartFilterRbacRoles!: Array<MSfpSmartFilterRbacRoleEntity>;
}
